import { firebaseConfig } from "./firebase";

export const isDevEnvironment = () => {
  return firebaseConfig?.projectId?.includes("sharebike-dev");
};
